import { useTranslation } from "react-i18next";

export default function LegalPage({ nsKey, testId }) {
  const { t } = useTranslation();
  const sections = t(`${nsKey}.sections`, { returnObjects: true }) || [];

  return (
    <main className="py-16 md:py-24" style={{ backgroundColor: "var(--vx-white)" }} data-testid={testId}>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="vx-eyebrow">{t(`${nsKey}.updated`)}</div>
        <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl font-bold" style={{ color: "var(--vx-navy)" }}>
          {t(`${nsKey}.title`)}
        </h1>
        <p className="mt-6 text-base leading-relaxed" style={{ color: "var(--vx-graphite)" }}>{t(`${nsKey}.intro`)}</p>

        <div className="vx-prose mt-8">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${testId}-section-${i}`}>
              <h2>{s.title}</h2>
              <p>{s.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}
